import BambooHrApiLogItem from "../Contents/LogAdmins/ApiLogAdmin/BambooHrApiLogItem.js";
import dateTimeHelper from "../Helpers/datetimeHelper.js";
import AuthService from "./authService.js";
import SearchParams from "../Elements/SearchParams";
import BambooHrApiLogSearchParams from "../Contents/LogAdmins/ApiLogAdmin/BambooHrApiLogSearchParams";

export default class BambooHrApiLogService {
  static GetListBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const authService = AuthService.getInstance();
    const tempSearchItem = { ...searchItem };
    tempSearchItem.StartDate = dateTimeHelper.startOfTheDay(
      tempSearchItem.StartDate
    );
    tempSearchItem.EndDate = dateTimeHelper.endOfTheDay(tempSearchItem.EndDate);

    let url = "/api/BambooHrApiLog/GetBySearchParams/?";
    const searchParams = new SearchParams(tempSearchItem, BambooHrApiLogSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    url += `searchParams=${searchParams.serializeForBackendCall()}`;
    url += `&clearCache=${clearCache}`;
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map(item => new BambooHrApiLogItem(item));
    }

    return [];
  }
}
